export var getCountLinkParams = function (props) {
    return {
        showFavorites: props.isFavoritesEnabled,
        handlers: props.handlers,
        isInFavorites: props.event.isInFavorites,
        linkUrl: props.event.linkUrl,
        count: props.event.marketLinesCount
    };
};
//# sourceMappingURL=getCountLinkParams.js.map